import { DotLottieReact } from '@lottiefiles/dotlottie-react'
import { useEffect, useState } from 'react'

const duration = 5000
const steps = 300

interface SubmissionOverlayProps {
  isFound?: boolean
}

export function SubmissionOverlay({ isFound = false }: SubmissionOverlayProps) {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    setProgress(0)
    const intervalTime = duration / steps
    let currentStep = 0

    const interval = setInterval(() => {
      currentStep++
      setProgress(Math.min(currentStep, 100))
    }, intervalTime)

    return () => clearInterval(interval)
  }, [])

  const title = isFound
    ? 'Welcome back to your '
    : 'One moment while our handsomest owls build your new '
  const paragraph = isFound
    ? 'Redirecting you to your dashboard...'
    : 'This should only take a minute!'

  return (
    <div className='mx-auto max-w-2xl text-center flex flex-col items-center'>
      <h1 className='font-serif text-balance text-4xl font-medium tracking-tight text-dw-black sm:text-[54px] leading-[1.2] font-semibold'>
        {title}
        <span className='text-dw-gold'>Web Wisdom</span>
      </h1>
      <p className='mt-8 text-pretty text-m font-medium text-gray-600 sm:text-xl/8'>
        {paragraph}
      </p>
      <div className='mt-8 w-full flex justify-center'>
        <DotLottieReact
          src='https://lottie.host/1416c383-b959-4792-b477-5f7e2c250c8a/mn0rZkhvKY.lottie'
          loop
          autoplay
          speed={1.5}
          style={{ width: 250, height: 250 }}
        />
      </div>
      <div className='mt-8 w-3/4 h-3 rounded-full bg-white overflow-hidden'>
        <div
          className='h-full bg-dw-yellow-accent rounded-full transition-all duration-50'
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  )
}
